import HelpTicket from "../CRUDs/entities/HelpTicket";

export class AutoTicket{

    /**
     * Класс для автовызова формы тикета с последующим автозаполнением.
     * @param {String} actionForm идентификатор формы предшествующей вызову формы тикета
     * @param {String} actionButton идентификатор кнопки для инициализации события
     */
    constructor(actionForm, actionButton){
        this.actionForm = actionForm;
        this.actionButton = actionButton;
    }

    /**
     * Функция для регистрации события вызова и автозаполнения формы тикета
     * @param {String} header Тема будущего тикета
     * @param {String} description Описание возникшей ошибки
     */
    createAutoTicket(header, description){
        $(this.actionForm).off('click', this.actionButton);
        $(this.actionForm).on('click', this.actionButton, ()=>{
            $(this.actionForm).modal('hide');
            const help_ticket = new HelpTicket();
            help_ticket.openModal('create');
            help_ticket.autocompleteForm(header, description);
        })
    }


}
